const generateHash = (input) =>
  [...input].reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);

export const generateColor = (input) => {
  const hash = generateHash(input ?? '');

  // use hsl here so we rely on one color + don't have very light colors
  return `hsl(${hash % 360}, 95%, 35%)`;
};
